// import { optionSelectAll } from "@/utils/commonUtils";

const danhSachDanhMucMenuHeThong = state => state.danhSachDanhMucMenuHeThong;
const cayDanhMucMenu = state => state.cayDanhMucMenu;
export default {
  danhSachDanhMucMenuHeThong,
  cayDanhMucMenu
};
